import React from 'react'

import { Content, Item } from './ListRow.styles'

export interface WrapperProps extends React.ComponentPropsWithoutRef<'div'> {
  $hasWarningText?: boolean
}

// This component is the base implementation for the different rows
export const Wrapper: React.FC<WrapperProps> = ({ children, ...props }) => (
  <Content {...props}>
    {React.Children.map(children, item => (
      <Item>{item}</Item>
    ))}
  </Content>
)
